var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconTwitter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#6e7191;}.c{clip-path:url(#a);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "a",
    cx: 15,
    cy: 15,
    r: 15,
    transform: "translate(1037.549 4525.548)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1058 -4367)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "b",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(1058 4367)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "c",
    transform: "translate(23.451 -155.549)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M20.994,4.463a8.618,8.618,0,0,1-2.477.682,4.314,4.314,0,0,0,1.889-2.383,8.66,8.66,0,0,1-2.74,1.05A4.3,4.3,0,0,0,10.35,7.749,12.229,12.229,0,0,1,1.47,3.235,4.283,4.283,0,0,0,.882,5.4,4.2,4.2,0,0,0,2.708,8.977C1.994,8.956.661,8.767.661,8.442v.052a4.4,4.4,0,0,0,3.548,4.2,3.957,3.957,0,0,1-1.05.147,4.094,4.094,0,0,1-.787-.073A4.325,4.325,0,0,0,6.4,15.758,8.628,8.628,0,0,1,1.05,17.626,9,9,0,0,1,0,17.563a12.2,12.2,0,0,0,6.6,1.931A12.166,12.166,0,0,0,18.894,7.245V6.689a8.754,8.754,0,0,0,2.1-2.225Zm0,0",
    transform: "translate(1042.052 4530.568)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwitter);
export default __webpack_public_path__ + "static/media/icon_twitter.d5464e15bf5facdf6be54033188361ba.svg";
export { ForwardRef as ReactComponent };